export const accidentFormMainIndividualInputs = {
  gridKey: "grid_container_individual",
  blockVisibility: true,
  inputsOptions: {
    personType: {
      key: "personType",
      label: "Вид судовладельца",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [
        {
          label: "Физическое лицо",
          value: "individual",
          key: "personType",
        },
        { label: "Юридическое лицо", value: "entity", key: "personType" },
      ],
    },
    sectionId: {
      key: "sectionId",
      label: "Участок",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    inspectorId: {
      key: "inspectorId",
      label: "Инспектор",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatRegNum: {
      key: "boatRegNum",
      label: "Регистрационный номер судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      pattern: {
        value: /^[А-Яа-яЁё]{2}\d{4}$/,
        message: `Формат: две буквы рус. алфавита и 4 цифры`,
      },
    },
    boatVidId: {
      key: "boatVidId",
      label: "Вид маломерного судна",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatTypeId: {
      key: "boatTypeId",
      label: "Тип маломерного судна",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatName: {
      key: "boatName",
      label: "Название маломерного судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    incidentDate: {
      key: "incidentDate",
      label: "Дата аварийного случая",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation: (value) => {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else {
          return true;
        }
      },
    },
    incidentTime: {
      key: "incidentTime",
      label: "Время аварийного случая",
      type: "time",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    incidentPlace: {
      key: "incidentPlace",
      label: "Место аварийного случая",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    incidentReasons: {
      key: "incidentReasons",
      label: "Причины аварийного случая",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerSurname: {
      key: "ownerSurname",
      label: "Фамилия судовладельца",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerName: {
      key: "ownerName",
      label: "Имя судовладельца",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerMidname: {
      key: "ownerMidname",
      label: "Отчество судовладельца",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerBirthDate: {
      key: "ownerBirthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation: (value) => {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else {
          return true;
        }
      },
    },
    ownerWorkplace: {
      key: "ownerWorkplace",
      label: "Дополнительная информация",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverSurname: {
      key: "driverSurname",
      label: "Фамилия судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverName: {
      key: "driverName",
      label: "Имя судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverMidname: {
      key: "driverMidname",
      label: "Отчество судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverBirthDate: {
      key: "driverBirthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        const today = new Date();
        const birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          return "Судоводитель не может быть младше 18 лет";
        } else {
          return true;
        }
      },
    },
    driverWorkplace: {
      key: "driverWorkplace",
      label: "Дополнительная информация",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverDrunk: {
      key: "driverDrunk",
      label: "Алкогольное опьянение",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [
        { value: true, label: "Да", key: "driverDrunk" },
        { value: false, label: "Нет", key: "driverDrunk" },
      ],
    },
  },
};

export const accidentFormMainEntityInputs = {
  gridKey: "grid_container_entity",
  blockVisibility: true,
  inputsOptions: {
    personType: {
      key: "personType",
      label: "Вид судовладельца",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [
        {
          label: "Физическое лицо",
          value: "individual",
          key: "personType",
        },
        { label: "Юридическое лицо", value: "entity", key: "personType" },
      ],
    },
    sectionId: {
      key: "sectionId",
      label: "Участок",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    inspectorId: {
      key: "inspectorId",
      label: "Инспектор",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatRegNum: {
      key: "boatRegNum",
      label: "Регистрационный номер судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customButton: true,
      buttonName: "Найти",
      customIcon: true,
      pattern: {
        value: /^[А-Яа-яЁё]{2}\d{4}$/,
        message: `Формат две буквы и 4 цифры`,
      },
    },
    boatVidId: {
      key: "boatVidId",
      label: "Вид маломерного судна",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatTypeId: {
      key: "boatTypeId",
      label: "Тип маломерного судна",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [],
    },
    boatName: {
      key: "boatName",
      label: "Название маломерного судна",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    incidentDate: {
      key: "incidentDate",
      label: "Дата аварийного случая",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation: (value) => {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else {
          return true;
        }
      },
    },
    incidentTime: {
      key: "incidentTime",
      label: "Время аварийного случая",
      type: "time",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    incidentPlace: {
      key: "incidentPlace",
      label: "Место аварийного случая",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
    },
    incidentReasons: {
      key: "incidentReasons",
      label: "Причины аварийного случая",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerLename: {
      key: "ownerLename",
      label: "Наименование судовладельца",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    ownerLeUnp: {
      key: "ownerLeUnp",
      label: "УНП судовладельца",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverSurname: {
      key: "driverSurname",
      label: "Фамилия судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverName: {
      key: "driverName",
      label: "Имя судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverMidname: {
      key: "driverMidname",
      label: "Отчество судоводителя",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverBirthDate: {
      key: "driverBirthDate",
      label: "Дата рождения",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      customValidation(value) {
        const today = new Date();
        const birthDate = new Date(value);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age < 18) {
          return "Судоводитель не может быть младше 18 лет";
        } else {
          return true;
        }
      },
    },
    driverWorkplace: {
      key: "driverWorkplace",
      label: "Дополнительная информация",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    driverDrunk: {
      key: "driverDrunk",
      label: "Алкогольное опьянение",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [
        { value: true, label: "Да", key: "driverDrunk" },
        { value: false, label: "Нет", key: "driverDrunk" },
      ],
    },
  },
};

export const accidentFormFooterInputs = {
  gridKey: "grid_container_footer",
  blockVisibility: true,
  inputsOptions: {
    incidentType: {
      key: "incidentType",
      label: "Вид транспортного аварийного случая",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: false,
      isSearchable: false,
      required: false,
      needInForm: true,
      options: [
        { value: 1, label: "Авария", key: "incidentType" },
        { value: 2, label: "Инцидент", key: "incidentType" },
      ],
    },
    deadAdult: {
      key: "deadAdult",
      label: "Количество погибших взрослых",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
    deadDrunk: {
      key: "deadDrunk",
      label: "Количество погибших в состоянии алкогольного опьянения (в том числе)",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
      // customValidation: (value, setError, clearErrors, getValues) => {
      //   const dataForm = getValues();
      //   console.log(dataForm);
      //   if (dataForm[""])
      //     setError("deadDrunk", {
      //       type: "manual",
      //       message:
      //         "Количество погибших в состоянии алкогольного опьянения (в том числе) не должно превышать количество детей + взрослых",
      //     });
      // },
    },
    deadChildren: {
      key: "deadChildren",
      label: "Количество погибших детей",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
    saveNum: {
      key: "saveNum",
      label: "Количество спасенных",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Только цифры",
      },
    },
    note: {
      key: "note",
      label: "Примечание",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
  },
};

export const causersListOptions = {
  keyTable: "causersList",
  caption: "Сведения о лицах, по вине которых произошел транспортный аварийный случай",
  nameColumn: [
    {
      value: "Фамилия",
      key: "surname",
      type: "text",
      neededInModal: true,
      required: true,
      placeholder: "Введите",
    },
    {
      value: "Имя",
      key: "name",
      type: "text",
      neededInModal: true,
      required: true,
      placeholder: "Введите",
    },
    {
      value: "Отчество",
      key: "midname",
      type: "text",
      neededInModal: true,
      required: false,
      placeholder: "Введите",
    },
    {
      value: "Дата рождения",
      key: "birthDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    {
      value: "Дополнительная информация",
      key: "workplace",
      type: "text",
      neededInModal: true,
      required: false,
      placeholder: "Введите",
    },
  ],
};
export const victimsListOptions = {
  keyTable: "victimsList",
  caption: "Сведения о пострадавших",
  nameColumn: [
    {
      value: "Фамилия",
      key: "surname",
      type: "text",
      neededInModal: true,
      required: true,
      placeholder: "Введите",
    },
    {
      value: "Имя",
      key: "name",
      type: "text",
      neededInModal: true,
      required: true,
      placeholder: "Введите",
    },
    {
      value: "Отчество",
      key: "midname",
      type: "text",
      neededInModal: true,
      required: false,
      placeholder: "Введите",
    },
    {
      value: "Дата рождения",
      key: "birthDate",
      type: "date",
      neededInModal: true,
      required: true,
    },
    {
      value: "Дополнительная информация",
      key: "workplace",
      type: "text",
      neededInModal: true,
      required: false,
      placeholder: "Введите",
    },
    {
      value: "Алкогольное опьянение",
      key: "drunk",
      type: "select",
      selectOptions: [
        { value: true, label: "Да", key: "drunk" },
        { value: false, label: "Нет", key: "drunk" },
      ],
      neededInModal: true,
      required: true,
    },
  ],
};

export const setOptionsForInputsATETransportAccident = (inputsOptions) => {
  let inputsOptionsValid = inputsOptions.map((item) => {
    return {
      value: item.value,
      label: item.label,
      key: "sectionId",
    };
  });

  if (accidentFormMainIndividualInputs.inputsOptions.sectionId.options.length === 0) {
    accidentFormMainIndividualInputs.inputsOptions.sectionId.options.push(...inputsOptionsValid);
  }
  if (accidentFormMainEntityInputs.inputsOptions.sectionId.options.length === 0) {
    accidentFormMainEntityInputs.inputsOptions.sectionId.options.push(...inputsOptionsValid);
  }
};

export const setOptionsForInputsUsers = (inputsOptions) => {
  accidentFormMainIndividualInputs.inputsOptions.inspectorId.options = inputsOptions.map((item) => {
    return { value: item.userid, label: item.name, key: "inspectorId" };
  });

  accidentFormMainEntityInputs.inputsOptions.inspectorId.options = inputsOptions.map((item) => {
    return { value: item.userid, label: item.name, key: "inspectorId" };
  });
};

export function setOptionsForBoatTypesFromDictionaries(types) {
  accidentFormMainIndividualInputs.inputsOptions.boatTypeId.options = types.map((item) => {
    item.key = "boatTypeId";
    return item;
  });
  accidentFormMainEntityInputs.inputsOptions.boatTypeId.options = types.map((item) => {
    item.key = "boatTypeId";
    return item;
  });
}

export function setOptionsForBoatKindsFromDictionaries(kinds) {
  accidentFormMainIndividualInputs.inputsOptions.boatVidId.options = kinds.map((item) => {
    item.key = "boatVidId";
    return item;
  });
  accidentFormMainEntityInputs.inputsOptions.boatVidId.options = kinds.map((item) => {
    item.key = "boatVidId";
    return item;
  });
}

export const getOptionsTransportAccident = (type = "individual") => {
  if (type === "individual") {
    return {
      main: accidentFormMainIndividualInputs,
      footer: accidentFormFooterInputs,
    };
  } else {
    return {
      main: accidentFormMainEntityInputs,
      footer: accidentFormFooterInputs,
    };
  }
};

export const setGridsByModeTransportAccident = (mode) => {
  if (mode === "view") {
    accidentFormMainIndividualInputs.gridKey = "grid_container_individual_view";
    accidentFormMainEntityInputs.gridKey = "grid_container_entity_view";
    accidentFormFooterInputs.gridKey = "grid_container_footer_view";
  } else {
    accidentFormMainIndividualInputs.gridKey = "grid_container_individual";
    accidentFormMainEntityInputs.gridKey = "grid_container_entity";
    accidentFormFooterInputs.gridKey = "grid_container_footer";
  }
};

export const setDisabledFieldsByAccidentType = (type, fields) => {
  fields.forEach((item) => {
    accidentFormFooterInputs.inputsOptions[item].disabled = type === 2 ? true : false;
  });
  return accidentFormFooterInputs;
};
